import { Card, Typography, Stack } from "@mui/material";
import { SearchOff } from "@mui/icons-material";
import { useTranslation } from "../../../hooks/useTranslation";

export const OrderNotFound = () => {
  const { translate } = useTranslation("pages.orderDetails.notFound");

  return (
    <Card
      elevation={0}
      sx={{
        p: 4,
        textAlign: "center",
        maxWidth: 520,
        mx: "auto",
        mt: 6,
        backgroundColor: (theme) => theme.palette.customBackground.box,
        borderLeft: "4px solid",
        borderLeftColor: "error.main",
      }}
    >
      <Stack spacing={2} alignItems="center">
        <SearchOff color="error" sx={{ fontSize: 48 }} />

        <Typography variant="h6" fontWeight={600}>
          {translate("title")}
        </Typography>

        <Typography variant="body2" color="text.secondary">
          {translate("description")}
        </Typography>
      </Stack>
    </Card>
  );
};
